// extracted by mini-css-extract-plugin
module.exports = {"root":"hero-module--root--3tpJX","fullheight":"hero-module--fullheight--2DBAF","wrapper":"hero-module--wrapper--vfZN3"};